import { Form, Input, Row, Col, Tag } from 'antd';
import { APP_LANGUAGES, REQUIRED_LANGUAGE } from '@/shared/config/languages';
import { RequiredLabel } from '../RequiredLabel';
import { getFieldNameWithLang, getFieldKey } from './utils';
import type { MultiLangProps, MultiLangField } from './types';

export const MultiLang = ({ activeLang, fields }: MultiLangProps) => {
  const sortedFields = [...fields].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

  const renderInput = (field: MultiLangField) => {
    const placeholder = field.placeholder ? field.placeholder : undefined;

    if (field.type === 'textarea') {
      return (
        <Input.TextArea
          disabled={field.disabled}
          rows={field.rows ?? 4}
          placeholder={placeholder}
          onBlur={field.onBlur}
          onFocus={field.onFocus}
          hidden={field.hidden}
          {...field.textareaProps}
        />
      );
    }

    return (
      <Input
        disabled={field.disabled}
        placeholder={placeholder}
        onBlur={field.onBlur}
        onFocus={field.onFocus}
        hidden={field.hidden}
      />
    );
  };

  return (
    <Row gutter={[8, 0]}>
      {sortedFields.map((field) => {
        const isRequiredLang = REQUIRED_LANGUAGE.includes(activeLang);
        return APP_LANGUAGES.map((lang) => {
          const fieldName = getFieldNameWithLang(field.name, lang.code);
          return (
            <Col key={getFieldKey(fieldName)} span={field.span ?? 24} hidden={lang.code !== activeLang}>
              <Form.Item
                label={
                  <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                    <RequiredLabel label={field.label} required={field.required && isRequiredLang} />
                    <Tag color='blue' style={{ margin: 0, fontSize: '10px', padding: '0 4px' }}>
                      {lang.code.toUpperCase()}
                    </Tag>
                  </span>
                }
                name={fieldName}
                rules={[
                  {
                    required: REQUIRED_LANGUAGE.includes(lang.code) && field.required,
                    message: field.requiredMessage || `${field.label} majburiy`,
                  },
                  ...(field.rules || []),
                ]}
                hidden={field.hidden}
              >
                {renderInput(field)}
              </Form.Item>
            </Col>
          );
        });
      })}
    </Row>
  );
};
